// @file Network requests related to photo album zip exports from surface

import FetchableObject from '@@/surface/api/fetchable_object'
import { HTTPMethod } from '@padlet/fetch'

interface PhotoAlbumZipResponse {
  download_url: string
  use_elvis_proxy?: boolean
}

interface PhotoAlbumZipErrorResponse {
  code: string
  user_email?: string
}

class PhotoAlbumZipApi extends FetchableObject {
  public static get photoAlbumZipUrl(): string {
    return `/padlets/\${ publicKey }/wishes/\${ wishHashid }/exports/photo-album/\${ format }`
  }

  /**
   * Request a photo album zip export for a wish with multiple attachments
   * @param options - Configuration options including publicKey and wishHashid
   * @returns Promise resolving to Response object
   */
  public static async exportPhotoAlbum({
    publicKey,
    wishHashid,
    format = 'json',
  }: {
    publicKey: string
    wishHashid: string
    format: 'zip' | 'json'
  }): Promise<Response> {
    const url = this.buildUrl(this.photoAlbumZipUrl, { publicKey, wishHashid, format })

    return await fetch(url, {
      method: HTTPMethod.get,
    })
  }
}

export { PhotoAlbumZipApi }
export type { PhotoAlbumZipErrorResponse, PhotoAlbumZipResponse }
